import { render } from "./m10finalMixed.vue?vue&type=template&id=c5c5ba30&scoped=true"
import script from "./m10finalMixed.vue?vue&type=script&lang=js"
export * from "./m10finalMixed.vue?vue&type=script&lang=js"

import "./m10finalMixed.vue?vue&type=style&index=0&id=c5c5ba30&lang=less&scoped=true"

import exportComponent from "D:\\00project\\36live\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5c5ba30"]])

export default __exports__